const notifications = {
  invalid_email: 'Adresse courriel invalide.',
  invalid_phone: 'Numéro de téléphone invalide.',
  at_least_one_contact_required: 'Veuillez fournir au moins un courriel ou un téléphone.',
};

export default notifications;
